import { FC } from 'react'

import { toRealWorldLanguage } from '../../../data/intl'
import { FeedObjectAnswer, FeedUserView } from '../../../interfaces'
import Img from '../../Img'
import styles from './AnswerProfile.module.css'

interface Props {
  answer: FeedObjectAnswer
  profile: FeedUserView
}

const AnswerProfile: FC<Props> = props => {
  const language = toRealWorldLanguage(props.profile.language)
  return (
    <div className={styles.profile}>
      <Img className={styles.profilePic} height={40} src={props.profile.profilePicUrl} width={40} />
      <div className={styles.profileData}>
        <div>
          {props.profile.userName && <strong>{props.profile.userName}</strong>}
          {props.profile.userName && props.profile.fullName && <span className={styles.sep}>.</span>}
          {props.profile.fullName && <span className={styles.fullName}>{props.profile.fullName}</span>}
        </div>
        <div className={styles.metadata}>
          {props.profile.bio?.value && (
            <>
              <span>{props.profile.bio?.value}</span>
              <span className={styles.sep}>·</span>
            </>
          )}
          {props.profile.location && <span>{props.profile.location}</span>}
          {props.profile.location && language && <span className={styles.sep}>·</span>}
          {language && <span>{language}</span>}
        </div>
      </div>
    </div>
  )
}

export default AnswerProfile
